// extracted by mini-css-extract-plugin
module.exports = {"button":"Error_button__2oR71"};